import solidarityDataService from './services/solidarity.data.service';
import SolidarityUserDataService from './services/solidarityUserData.service';
import InitialDataService from './initialData/initialData.service';
import solidarityService from './services/solidarity.service';

let solidarityCommon = angular.module('solidarity.common', [])

  .service('solidarityDataService', solidarityDataService)
  .service('SolidarityUserDataService', SolidarityUserDataService)
  .service('SolidarityInitialService', InitialDataService)
  .service('solidarityService', solidarityService)

  .name;

export default solidarityCommon;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/common/solidarity.common.js